/** @jsxImportSource theme-ui */
import { Grid, Flex } from 'theme-ui';
import CompanyInfo from './CompanyInfo';
import CompanyDeletionSchedule from './CompanyDeletionSchedule';
import CompanyAdministrators from './CompanyAdministrators';
import CompanyLicenses from './CompanyLicenses';
import CompanyInvoices from './CompanyInvoices';
import CompanyApiKey from './CompanyApiKey';
import CompanySubscriptions from './CompanySubscriptions';
import CompanyScheduledChanges from './CompanyScheduledChanges';
import CompanyUsages from './CompanyUsages';

const CompanyDetails = () => {
    return (
        <Grid>
            <Flex
                sx={{
                    gap: 4,
                    flexDirection: 'column',
                }}
            >
                <CompanyInfo />
                <CompanyDeletionSchedule />
                <CompanyApiKey />
                <CompanyAdministrators />
                <CompanyLicenses />
                <CompanyInvoices />
                <CompanySubscriptions />
                <CompanyScheduledChanges />
                <CompanyUsages />
            </Flex>
        </Grid>
    );
};

export default CompanyDetails;
